module.exports = __webpack_public_path__ + "img/print-table-icon.681a8e19.svg";